<template>
  <div class="layerWrapper active" style="display: block;" tabindex="0">
    <div class="cbox layerBox popWidM" ref="layerBox"
      :style="{'display': 'block', 'opacity': '1', ...style}">
      <div class="cart-popup__dialog NCACroa_cont02_popUp">
        <div class="cart-popup__header" v-if="showHeader">
          <span class="cart-popup__header-text" style="color:#2c2c2c;">
            {{ headerText }}
            <a @click="closePopup" data-dismiss="modal" aria-label="Close" aria-hidden="true" class="cart-popup__close">
              <img src="@/views/survey/images/NCACroatia_close.png" alt="닫기">
            </a>
          </span>
        </div>
        <div
          v-if="content"
          v-html="content"
          class="cart-popup__content payment"
        ></div>
        <div
          v-else
          class="cart-popup__content payment"
        >
          <div class="cart-popup__item-info amway-theme" style="padding:0;">
            <div class="os_noticeRes">
              <SurveyPicture
                v-for="content in activityContent"
                :key="content.image"
                :src="require(`../images/${content.image}`)"
                alt="2022 크로아티아 다이아몬드 인비테이셔널 - 액티비티 정보 안내"
                :description="content.description"
                @load:image="layerTypeBasic"
              />
            </div>
          </div>
        </div>
        <div v-if="showConfirmBtn"
          class="cart-popup__item-link" style="border:none;">
          <a @click="closePopup" class="bt-akl-blue btn_close NCACroa_cont03_popup">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SURVEY, CLOSE_POPUP } from '@/store/actions/survey'
import SurveyPicture from './SurveyPicture.vue'
// import { activityPopupContent } from '@/utils/survey'

export default {
  name: 'SurveyPopupLayer',
  components: {
    SurveyPicture,
  },
  data() {
    return {
      htmlEl: document.querySelector("html"),
      uiLayerMask: document.getElementById("uiLayerMask"),
      style: {},
      activityContent: [],
    }
  },
  computed: {
    ...mapState(SURVEY, {
      showHeader: state => state.popup.showHeader,
      headerText: state => state.popup.headerText,
      content: state => state.popup.content,
      showConfirmBtn: state => state.popup.showConfirmBtn
    })
  },
  methods: {
    layerTypeBasic(e) {
      const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      const topPosition = winHeight / 2;
      const leftPosition = winWidth / 2;

      const $layerBox = this.$refs.layerBox;
      const targetWidth = $layerBox.clientWidth;
      const targetHeight = $layerBox.clientHeight;

      if (winHeight < 481) {
        this.style = {
          'position': 'absolute',
          'top': '10px',
          'left': '0',
          'right': '0',
          'width': '100%',
          'height': 'auto',
          'margin-top': '0',
          'margin-left': '0',
          'margin-bottom': '12px',
        };
      } else if (targetHeight > winHeight) {
        this.style = {
          'position': 'absolute',
          'top': '3%',
          'left': '0',
          'right': '0',
          'max-width': '98%',
          'height': 'auto',
          'margin': '0 auto',
          'margin-bottom': '3%',
        };
      } else {
        this.style = {
          'top': `${topPosition}px`,
          'left': `${leftPosition}px`,
          'margin-top': `${-(targetHeight / 2)}px`,
          'margin-left': `${-(targetWidth / 2)}px`,
        };
      }
    },
    closePopup() {
      this.$store.dispatch(`${SURVEY}/${CLOSE_POPUP}`);
    }
  },
  mounted() {
    this.htmlEl.classList.add("scrollLock");
    this.uiLayerMask.classList.add("on");
    this.uiLayerMask.style.display = 'block';
    window.addEventListener('resize', this.layerTypeBasic);
    this.layerTypeBasic();
  },
  destroyed() {
    this.htmlEl.classList.remove("scrollLock");
    this.uiLayerMask.classList.remove("on");
    this.uiLayerMask.style.display = 'none';
    window.removeEventListener('resize', this.layerTypeBasic);
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyPopupLayer.vue